



































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';   
import {DxLookup} from 'devextreme-vue/lookup';
import {DxButton} from 'devextreme-vue/button';
import _ from 'lodash';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxCheckBox, DxTextBox, DxTagBox } from 'devextreme-vue';
import { ClientReportOptionDto } from '../../models/client/ClientReportOptionDto';
import { ClientService } from '@/service/ClientService';
import {DxValidator, DxRequiredRule, DxPatternRule} from 'devextreme-vue/validator';
import { UserDto } from '../../models/UserDto';
import { ClientDetailDto } from '../../models/client/ClientDto';

@Component({
    components: { 
        DxLookup,
        DxButton,
        DxCheckBox,
        DxValidator,
        DxRequiredRule,
        DxPatternRule,
        DxTextBox,
        DxTagBox
    }
})

export default class ClientSetupMain extends Vue {
    $refs: Vue['$refs'] & {
    } = {};

    private readonly emailSeparator: string = ';';
    private primaryEmailSource: Array<string> = [];
    private ccEmailSource: Array<string> = [];

    get primaryEmail() {
        return this.clientEmail && this.clientEmail.trim() ? this.clientEmail.split(this.emailSeparator) : [];
    }

    set primaryEmail(value:Array<string>) {
        if(this.newTagValue) {
            if(!value.find(x=> this.newTagValue === x)) {
                value.push(this.newTagValue)
            }
            this.newTagValue=null;
        }
        this.$emit('update:clientEmail', value.join(this.emailSeparator))
    }

    get ccEmail() {
        return this.clientCCEmail && this.clientCCEmail.trim() ? this.clientCCEmail.split(this.emailSeparator) : [];
    }

    set ccEmail(value:Array<string>) {
        if(this.newTagValue) {
            if(!value.find(x=> this.newTagValue === x)) {
                value.push(this.newTagValue)
            }
            this.newTagValue=null;
        }
        this.$emit('update:clientCCEmail', value.join(this.emailSeparator))
    }

    get assignedUsers () {
        return this.clientUsers ? this.clientUsers : []
    }

    set assignedUsers (value: Array<string>) {
        this.$emit('update:clientUsers', value)
    }

    get shortName() {
        return this.clientShortName || "";
    }

    set shortName(value: string) {
        this.$emit('update:clientShortName', value)
    }

    get active() {
        return this.clientActive ? true : false;
    }

    set active(value: boolean) {
        this.$emit('update:clientActive', value)
    }

    @Prop({default : false}) 
    visible!: boolean;

    @Prop({default : ''})
    clientId!: Guid;

    @Prop({default: () => new Array<UserDto>() })
    userDataSource!: Array<UserDto>;

    @Prop()
    clientEmail!: string | null;

    @Prop()
    clientCCEmail!: string | null;

    @Prop()
    clientShortName!: string | null;

    @Prop()
    clientUsers!: Array<string>;

    @Prop()
    clientActive!: boolean | null;

    get ClientId() : Guid {
        return this.clientId;
    }

    get visibility() : boolean {
        return this.visible;
    }

    constructor() {
        super();
    }

    mounted() {
        this.setUpEmailSources();
    }

    setUpEmailSources() {
        this.ccEmail.forEach(x=> {
            this.ccEmailSource.push(x);
        });

        this.primaryEmail.forEach(x=> {
            this.primaryEmailSource.push(x)
        });
    }

    get usersList() {
        return this.userDataSource;
    }

    private newTagValue: string | null = null;
    onCustomItemCreatingEvent(e:{component: DxTagBox, text: string, element: HTMLElement, customItem: string}, source: string) {
        
        if(source == "primary") {
            if(!this.primaryEmailSource.find(x=> e.text)) {
                this.primaryEmailSource.push(e.text);
            }
            else {
                this.newTagValue = e.text;
            }
        }

        if(source == "cc") {
            if(!this.ccEmailSource.find(x=> e.text)) {
                this.ccEmailSource.push(e.text);
            }
            else {
                this.newTagValue = e.text;
            }
        }
    }

    onTagBoxOpened(e:any) {
        e.component.content().remove();
    }

    checkEmailValidation(text: string) {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(text)
    }

    tagItemStyle(e:any) {
        let isValid = this.checkEmailValidation(e);
        if(!isValid) {
            return { 'background-color' : '#e43c3c' }
        }
        return {};
    }

}
